module.exports = "tbody>tr>td.point{\r\n    text-align:right;\r\n    padding-left: 0;\r\n    padding-right:10%;\r\n    width:15%;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/a0130-mcourse/mcourse.component.css
// module id = ./src/app/a0130-mcourse/mcourse.component.css
// module chunks = main